import common from "../common/lang";

var menuItems = {
    HOME: "innEBOK",
    EDIT: "EDITION",
    CREATE: "CREATION",
    Measurements: "Measurements",
    Agreements: "Agreements",
    MyAccount: "My Account"
};

var measurements = {
    PPM: "Medium Consumption Place",
    Medium: " Medium",
    CounterSerial: "Counter serial",
    DeviceType: "Counter type",
    Tariff: "Tariff",
    Phasicity: "Phasicity",
    Multiply: "Multiply",
    DevicePlace: "Counter mounting place",
    Consumption: "Consumption",
    ConsumptionEnergy: "Consumption(Energy)",
    ConversionCoeff: "Converersion factor",
    ReadoutDate: "Readout date",
    Zone: "Zone",
    CounterState: "State",
    ConsumptionDate: "Consumption date",
    Source: "Source",
    Measurement: "Measurement",
    AvgPeriod: "Averaging period",
    ChartType: "Chart type",
    BarChart: "bar",
    LineChart: "line",
    Agreement: "Agreement",
    States: "States",
    AgreementFrom: "Agreement from",
    AgreementTo: "Agreement to",
    DateFrom: "Date from",
    DateTo: "Date to",
    From: "From",
    To: "To",
    Max_Power: "Max power",
    ProfileChart: "Profile Chart",
    SameAxis: "One scale"
}

var usercompanies = {
    MarketParticipants: "Market Participants",
    Id: "Id",
    Nip: "NIP/ PESEL",
    Name: "Name"
}

var questions = {
    Delete_Object: "Delete object?"
};

var agreements = {
    OwnerName: "Owner name",
    PartnerName: "Partner name",
    IsArchive: "Is Archive",
    Is_Permitted: "Widoczna",
    ShowAgreements: "Show agreements",
    UserAgreements: "User's agreements"
}

var dataStatus = {
    DataStatus_1: 'Verified data',
    DataStatus_2: 'Uncertain data',
    DataStatus_3: 'No data',
    DataStatus_4: 'Manually entered data',
    DataStatus_5: 'Forecast data',
    DataStatus_6: 'Data out of the timezone',
};

var measure = {
    ECP: "Positive active energy",
    ECO: "Negative active energy",
    EBP_Q2: "Imported inductive reactive energy Q2",
    EBO: "Exported capacitive reactive energy",
    EBO_Q3: "Exported inductive reactive energy Q3",
    EPG: "Gas consumption",
    EPG_WSK: "Converersion factor",

    // ELECTRICAL
    ELECTRICAL_ECP: "Positive active energy (PAE)",
    ELECTRICAL_ECP_short: "PAE",
    
    ELECTRICAL_ECO: "Negative active energy (NAE)",
    ELECTRICAL_ECO_short: "NAE",

    ELECTRICAL_EBP: "Imported inductive reactive energy (IIRE_Q1)",
    ELECTRICAL_EBP_short: "IIRE_Q1",

    ELECTRICAL_EBP_Q2: "Imported capacitive reactive energy (ICRE_Q2)",
    ELECTRICAL_EBP_Q2_short: "ICRE_Q2",

    ELECTRICAL_EBO_Q3: "Exported inductive reactive energy (EIRE_Q3)",
    ELECTRICAL_EBO_Q3_short: "EIRE_Q3",

    ELECTRICAL_EBO: "Exported capacitive reactive energy (ECRE_Q4)",
    ELECTRICAL_EBO_short: "ECRE_Q4",

    ELECTRICAL_EPG: "Incorrect configuration! (EPB)",
    ELECTRICAL_EPG_short: "EPG",

    ELECTRICAL_EPG_WSK: "Incorrect configuration! (EPG_WSPK)",
    ELECTRICAL_EPG_WSK_short: "EPG_WSPK",

    // GAS
    GAS_ECP: "Gas consumption (GC_kWh)",
    GAS_ECP_short: "GC_kWh",

    GAS_ECO: "Incorrect configuration (ECO)",
    GAS_ECO_short: "Incorrect configuration (ECO)",

    GAS_EBP: "Incorrect configuration (EBP)",
    GAS_EBP_short: "Incorrect configuration (EBP)",

    GAS_EBP_Q2: "Incorrect configuration (EBP_Q2)",
    GAS_EBP_Q2_short: "Incorrect configuration (EBP_Q2)",

    GAS_EBO: "Incorrect configuration (EBO)",
    GAS_EBO_short: "Incorrect configuration (EBO)",

    GAS_EBO_Q3: "Incorrect configuration (EBO_Q3)",
    GAS_EBO_Q3_short: "Incorrect configuration (EBO_Q3)",

    GAS_EPG: "Gas consumption (GC_m3)",
    GAS_EPG_short: "GC_m3",

    GAS_EPG_WSK: "Gas converersion factor (GCF)",
    GAS_EPG_WSK_short: "GCF",

    // WATER
    WATER_ECP: "Water consumption (WC)",
    WATER_ECP_short: "WC",

    WATER_ECO: "Incorrect configuration (ECO)",
    WATER_ECO_short: "Incorrect configuration (ECO)",

    WATER_EBP: "Incorrect configuration (EBP)",
    WATER_EBP_short: "Incorrect configuration (EBP)",

    WATER_EBP_Q2: "Incorrect configuration (EBP_Q2)",
    WATER_EBP_Q2_short: "Incorrect configuration (EBP_Q2)",

    WATER_EBO: "Incorrect configuration (EBO)",
    WATER_EBO_short: "Incorrect configuration (EBO)",

    WATER_EBO_Q3: "Incorrect configuration (EBO_Q3)",
    WATER_EBO_Q3_short: "Incorrect configuration (EBO_Q3)",

    WATER_EPG: "Incorrect configuration (EPG)",
    WATER_EPG_short: "Incorrect configuration (EPG)",

    WATER_EPG_WSK: "Incorrect configuration (EPG_WSK)",
    WATER_EPG_WSK_short: "Incorrect configuration(EPG_WSK)",

    // AIR
    AIR_ECP: "Air consumption (AC)",
    AIR_ECP_short: "AC",

    AIR_ECO: "Incorrect configuration (ECO)",
    AIR_ECO_short: "Incorrect configuration (ECO)",

    AIR_EBP: "Incorrect configuration (EBP)",
    AIR_EBP_short: "Incorrect configuration (EBP)",

    AIR_EBP_Q2: "Incorrect configuration (EBP_Q2)",
    AIR_EBP_Q2_short: "Incorrect configuration (EBP_Q2)",

    AIR_EBO: "Incorrect configuration (EBO)",
    AIR_EBO_short: "Incorrect configuration (EBO)",

    AIR_EBO_Q3: "Incorrect configuration (EBO_Q3)",
    AIR_EBO_Q3_short: "Incorrect configuration (EBO_Q3)",

    AIR_EPG: "Incorrect configuration (EPG)",
    AIR_EPG_short: "Incorrect configuration (EPG)",

    AIR_EPG_WSK: "Incorrect configuration (EPG_WSK)",
    AIR_EPG_WSK_short: "Incorrect configuration(EPG_WSK)",

    // STEAM
    STEAM_ECP: "Heat consumption (ESC)",
    STEAM_ECP_short: "MESC",

    STEAM_ECO: "Media consumption (VSC)",
    STEAM_ECO_short: "VSC",

    STEAM_EBP: "Incorrect configuration (EBP)",
    STEAM_EBP_short: "Incorrect configuration (EBP)",

    STEAM_EBP_Q2: "Incorrect configuration (EBP_Q2)",
    STEAM_EBP_Q2_short: "Incorrect configuration (EBP_Q2)",

    STEAM_EBO: "Incorrect configuration (EBO)",
    STEAM_EBO_short: "Incorrect configuration (EBO)",

    STEAM_EBO_Q3: "Incorrect configuration (EBO_Q3)",
    STEAM_EBO_Q3_short: "Incorrect configuration (EBO_Q3)",

    STEAM_EPG: "Incorrect configuration (EPG)",
    STEAM_EPG_short: "Incorrect configuration (EPG)",

    STEAM_EPG_WSK: "Incorrect configuration (EPG_WSK)",
    STEAM_EPG_WSK_short: "Incorrect configuration(EPG_WSK)",

    // HEAT
    HEAT_ECP: "Central energy heating (ECH)",
    HEAT_ECP_short: "ECH",

    HEAT_ECO: "Central heating (VCH))",
    HEAT_ECO_short: "VCH",

    HEAT_EBP: "Incorrect configuration (EBP)",
    HEAT_EBP_short: "Incorrect configuration (EBP)",

    HEAT_EBP_Q2: "Incorrect configuration (EBP_Q2)",
    HEAT_EBP_Q2_short: "Incorrect configuration (EBP_Q2)",

    HEAT_EBO: "Incorrect configuration (EBO)",
    HEAT_EBO_short: "Incorrect configuration (EBO)",

    HEAT_EBO_Q3: "Incorrect configuration (EBO_Q3)",
    HEAT_EBO_Q3_short: "Incorrect configuration (EBO_Q3)",

    HEAT_EPG: "Incorrect configuration (EPG)",
    HEAT_EPG_short: "Incorrect configuration (EPG)",

    HEAT_EPG_WSK: "Incorrect configuration (EPG_WSK)",
    HEAT_EPG_WSK_short: "Incorrect configuration(EPG_WSK)",

    // NITROGEN
    NITROGEN_ECP: "Nitrogen consumption (NC)",
    NITROGEN_ECP_short: "NC",

    NITROGEN_ECO: "Incorrect configuration (ECO)",
    NITROGEN_ECO_short: "Incorrect configuration (ECO)",

    NITROGEN_EBP: "Incorrect configuration (EBP)",
    NITROGEN_EBP_short: "Incorrect configuration (EBP)",

    NITROGEN_EBP_Q2: "Incorrect configuration (EBP_Q2)",
    NITROGEN_EBP_Q2_short: "Incorrect configuration (EBP_Q2)",

    NITROGEN_EBO: "Incorrect configuration (EBO)",
    NITROGEN_EBO_short: "Incorrect configuration (EBO)",

    NITROGEN_EBO_Q3: "Incorrect configuration (EBO_Q3)",
    NITROGEN_EBO_Q3_short: "Incorrect configuration (EBO_Q3)",

    NITROGEN_EPG: "Incorrect configuration (EPG)",
    NITROGEN_EPG_short: "Incorrect configuration (EPG)",

    NITROGEN_EPG_WSK: "Incorrect configuration (EPG_WSK)",
    NITROGEN_EPG_WSK_short: "Incorrect configuration(EPG_WSK)",

    // OTHER
    OTHER_ECP: "Medium consumption (MC)",
    OTHER_ECP_short: "MC",

    OTHER_ECO: "Incorrect configuration (ECO)",
    OTHER_ECO_short: "Incorrect configuration (ECO)",

    OTHER_EBP: "Incorrect configuration (EBP)",
    OTHER_EBP_short: "Incorrect configuration (EBP)",

    OTHER_EBP_Q2: "Incorrect configuration (EBP_Q2)",
    OTHER_EBP_Q2_short: "Incorrect configuration (EBP_Q2)",

    OTHER_EBO: "Incorrect configuration (EBO)",
    OTHER_EBO_short: "Incorrect configuration (EBO)",

    OTHER_EBO_Q3: "Incorrect configuration (EBO_Q3)",
    OTHER_EBO_Q3_short: "Incorrect configuration (EBO_Q3)",

    OTHER_EPG: "Incorrect configuration (EPG)",
    OTHER_EPG_short: "Incorrect configuration (EPG)",

    OTHER_EPG_WSK: "Incorrect configuration (EPG_WSK)",
    OTHER_EPG_WSK_short: "Incorrect configuration(EPG_WSK)",

    "Chart_Electrical_Energy_ECP": "Energia czynna [kWh]",
    "Chart_Electrical_Power_ECP": "Moc czynna [kWh]",

    "Chart_Electrical_Energy_ECO": "Energia bierna [kVArh]",
    "Chart_Electrical_Power_ECO": "Energia bierna [kVAr]",

    "Chart_Electrical_M3_ECO": "brak",
    "Chart_Electrical_M3_Power_ECO": "brak",



    "Chart_Gas_Energy_ECP": "Energia [kWh]",
    "Chart_Gas_Power_ECP": "Moc [kW]",

    "Chart_Gas_Energy_ECO": "brak",
    "Chart_Gas_Power_ECO": "brak",

    "Chart_Gas_M3_ECO": "Obj�to�� [m^3]",
    "Chart_Gas_M3_Power_ECO": "Przep�yw [m^3/h]",


    "Chart_Water_Energy_ECP": "Obj�to�� [m^3]",
    "Chart_Water_Power_ECP": "Przep�yw [m^3]",

    "Chart_Water_Energy_ECO": "brak",
    "Chart_Water_Power_ECO": "brak",

    "Chart_Water_M3_ECO": "brak",
    "Chart_Water_M3_Power_ECO": "brak",


    "Chart_Air_Energy_ECP": "Obj�to�� [m^3]",
    "Chart_Air_Power_ECP": "Przep�yw [m^3]",

    "Chart_Air_Energy_ECO": "brak",
    "Chart_Air_Power_ECO": "brak",

    "Chart_Air_M3_ECO": "brak",
    "Chart_Air_M3_Power_ECO": "brak",


    "Chart_Steam_Energy_ECP": "Energia [GJ]",
    "Chart_Steam_Power_ECP": "Moc [GW]",

    "Chart_Steam_Energy_ECO": "Obj�to�� [m^3]",
    "Chart_Steam_Power_ECO": "Przep�yw [m^3]",

    "Chart_Steam_M3_ECO": "brak",
    "Chart_Steam_M3_Power_ECO": "brak",


    "Chart_Heat_Energy_ECP": "Energia [GJ]",
    "Chart_Heat_Power_ECP": "Moc [GW]",

    "Chart_Heat_Energy_ECO": "Obj�to�� [m^3]",
    "Chart_Heat_Power_ECO": "Przep�yw [m^3/h]",

    "Chart_Heat_M3_ECO": "brak",
    "Chart_Heat_M3_Power_ECO": "brak",


    "Chart_Nitrogen_Energy_ECP": "Obj�to�� [m^3]",
    "Chart_Nitrogen_Power_ECP": "Przep�yw [m^3/h]",

    "Chart_Nitrogen_Energy_ECO": "brak",
    "Chart_Nitrogen_Power_ECO": "brak",

    "Chart_Nitrogen_M3_ECO": "brak",
    "Chart_Nitrogen_M3_Power_ECO": "brak",


    "Chart_Other_Energy_ECP": "Obj�to�� [m^3]",
    "Chart_Other_Power_ECP": "Przep�yw [m^3/h]",

    "Chart_Other_Energy_ECO": "brak",
    "Chart_Other_Power_ECO": "brak",

    "Chart_Other_M3_ECO": "brak",
    "Chart_Other_M3_Power_ECO": "brak",

}

var exports = {
    "15min": "15min",
    "60min": "60min",
    XLSX: "XLSX",
    CSV: "CSV"
}

var localeGB = {
    ...common["gb"],
    ...menuItems,
    ...questions,
	...measurements,
    ...usercompanies,
    ...agreements,
    ...dataStatus,
    ...measure,
    ...exports
};

export default localeGB;
